import { getMemberSubscriptions } from './get-member-subscriptions';
export const getFutureMemberSubscription = () => { var _a; return (_a = getMemberSubscriptions()) === null || _a === void 0 ? void 0 : _a.future; };
